<template>
  <v-app-bar color="indigo" theme="dark">
    <slot name="menudrawer"></slot>
    <slot name="title"></slot>
    <slot name="billinggroup"></slot>
    <v-spacer></v-spacer>
    <slot name="logininfo"></slot>
  </v-app-bar>
</template>
<script></script>
